const $ = require("../../node_modules/jquery/dist/jquery.min");
const Cookies = require("js-cookie");

module.exports = {
  init: () => {
    const noticePopupRejected = Cookies.get("noticePopupRejected");

    if (noticePopupRejected === "1") {
      $(".noticebar").hide();
    } else {
      $(".noticebar").show();
    }

    $(".noticebar-dismiss").click(() => {
      Cookies.set("noticePopupRejected", "1", { expires: 14 });
      $(".noticebar").hide();
      $(".noticebar-follows").removeClass("noticebar-follows");
      return false;
    });
  }
};
